import { __assign } from "tslib";
import React, { useContext, useState, useRef, useEffect, useCallback } from 'react';
import { MAX_TEXT_LENGTH } from '../..';
import { ComponentContext } from '../../contexts';
import { COLORS, LABEL_FONT_FAMILY } from '../../constants';
import { KEYBOARD_KEY } from '../../interfaces';
import { getFontStyles } from './utils';
var MOUSE_CLICK_SPEED = 200;
export var Text = function (_a) {
    var definition = _a.definition, _b = _a.editing, editing = _b === void 0 ? false : _b, onChange = _a.onChange, _c = _a.onBlur, onBlur = _c === void 0 ? null : _c, _d = _a.onFocus, onFocus = _d === void 0 ? null : _d, _e = _a.onClick, onClick = _e === void 0 ? null : _e, _f = _a.onMouseEnter, onMouseEnter = _f === void 0 ? null : _f, _g = _a.onMouseLeave, onMouseLeave = _g === void 0 ? null : _g;
    var stateText = definition.text, _h = definition.color, color = _h === void 0 ? COLORS.TEXT : _h, width = definition.width, height = definition.height;
    var _j = useState(stateText), revertText = _j[0], setRevertText = _j[1];
    var PointerArea = useContext(ComponentContext).PointerArea;
    var inputRef = useRef();
    var mouseClickTimer = useRef(null);
    var mouseClicked = useRef(false);
    // This is needed to update text synchronously (prevent caret jump, etc.)
    var _k = useState(stateText), text = _k[0], setText = _k[1];
    useEffect(function () {
        if (!editing) {
            setRevertText(stateText);
        }
    }, [editing]);
    useEffect(function () {
        if (editing) {
            var el_1 = inputRef.current;
            var handleEnter_1 = function (e) {
                if (e.key.toLowerCase() === KEYBOARD_KEY.ENTER) {
                    inputRef.current.blur();
                }
            };
            var handleEvent_1 = function (e) {
                e.stopPropagation();
            };
            el_1.addEventListener('keyup', handleEnter_1);
            var handledEventTypes_1 = ['keydown', 'keyup', 'mousedown', 'mouseup'];
            handledEventTypes_1.forEach(function (type) { return el_1.addEventListener(type, handleEvent_1); });
            return function () {
                handledEventTypes_1.forEach(function (type) { return el_1.removeEventListener(type, handleEvent_1); });
                el_1.removeEventListener('keyup', handleEnter_1);
            };
        }
        return function () { };
    }, [editing]);
    useEffect(function () {
        if (!editing) {
            setText(stateText);
        }
    }, [stateText, editing]);
    var handleChange = useCallback(function (e) {
        var newText = e.target.value;
        if (newText.length) {
            onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
        }
        setText(newText);
    }, [onChange]);
    var handleMouseDown = useCallback(function () {
        clearTimeout(mouseClickTimer.current);
        mouseClicked.current = true;
        mouseClickTimer.current = setTimeout(function () {
            mouseClicked.current = false;
        }, MOUSE_CLICK_SPEED);
    }, []);
    var handleMouseUp = useCallback(function () {
        clearTimeout(mouseClickTimer.current);
        if (mouseClicked.current) {
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    }, [onClick]);
    var handleBlur = useCallback(function () {
        if (!text.length) {
            onChange === null || onChange === void 0 ? void 0 : onChange(revertText);
            setText(revertText);
        }
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    }, [onBlur, onChange, revertText, text.length]);
    return (React.createElement("svg", { onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        React.createElement(PointerArea, { width: width, height: height }),
        React.createElement("text", { dominantBaseline: "text-before-edge", fill: editing ? COLORS.TRANSPARENT : color, fontFamily: LABEL_FONT_FAMILY, fontSize: "".concat(definition.fontSize, "px"), style: {
                userSelect: 'none',
            } }, text),
        editing ? (React.createElement("foreignObject", { width: width, height: height, style: { pointerEvents: 'all', overflow: 'visible' } },
            React.createElement("input", { ref: inputRef, type: "text", maxLength: MAX_TEXT_LENGTH, onChange: handleChange, onFocus: onFocus, onBlur: handleBlur, style: __assign({ position: 'fixed', width: width + 50, backgroundColor: 'transparent', color: color, padding: 0, margin: 0 }, getFontStyles(definition)), value: text }))) : null));
};
//# sourceMappingURL=text.js.map